import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { EmptyStateImage } from './EmptyStateImage.esm.js';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(2, 0, 0, 0)
    },
    action: {
      marginTop: theme.spacing(2)
    },
    imageContainer: {
      position: "relative"
    }
  }),
  { name: "BackstageEmptyState" }
);
function EmptyState(props) {
  const { title, description, missing, action } = props;
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(
    Grid,
    {
      container: true,
      direction: "row",
      justifyContent: "space-around",
      alignItems: "flex-start",
      className: classes.root,
      spacing: 2
    },
    /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12, md: 6 }, /* @__PURE__ */ React.createElement(Grid, { container: true, direction: "column" }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: true }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, title)), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: true }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, description)), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: true, className: classes.action }, action))),
    /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12, md: 6, className: classes.imageContainer }, typeof missing === "string" ? /* @__PURE__ */ React.createElement(EmptyStateImage, { missing }) : missing.customImage)
  );
}

export { EmptyState };
//# sourceMappingURL=EmptyState.esm.js.map
